import { View } from 'react-native';

import DrawerPage from 'components/layout/drawer-page';
import { SpotifyTile } from 'pages/loyalty/loyalty-partners/spotify';
import { WalmartOffer } from 'pages/loyalty/loyalty-partners/walmart/walmart-offer';
import { t } from 'state/intl/translations';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'state/launchdarkly/flags';
import { spacing } from 'styles/constants';

export default function Partnerships() {
  const headerText = t('partnerOffers');

  const showSpotifyTile = useFlag(LaunchDarklyFlag.SHOW_SPOTIFY_PARTNERSHIP);

  return (
    <DrawerPage headerText={headerText}>
      <View style={{ gap: spacing.$4 }}>
        <WalmartOffer />
        {showSpotifyTile && <SpotifyTile />}
      </View>
    </DrawerPage>
  );
}
